import { ReactNode } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup as MUIRadioGroup,
  RadioGroupProps as MUIRadioGroupProps,
  SxProps,
} from '@mui/material';

import RadioButton from './RadioButton';

type CustomProps = {
  label?: string;
};

type AtomMUIProps = {
  children?: ReactNode;
  defaultValue?: any;
  classes?: any;
  row?: boolean;
  sx?: SxProps;
};

export type RadioGroupProps = CustomProps & AtomMUIProps;

export const RadioGroup = (props: RadioGroupProps) => {
  const { label = '', ...data } = props;

  const MUIProps: MUIRadioGroupProps = data;

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <MUIRadioGroup {...MUIProps} />
    </FormControl>
  );
};

RadioGroup.RadioButton = RadioButton;

export default RadioGroup;
